 // Judge.me Datum-Format korrigieren auf pdp
(function(){
  function formatDateInNode(node){
    if(!node)return;
    var text=node.textContent;
    if(!text||text.indexOf('/')===-1)return;
    var newText=text.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g,function(_,d,m,y){
      var day=d.length===1?'0'+d:d;
      var month=m.length===1?'0'+m:m;
      return day+'.'+month+'.'+y;
    });
    if(newText!==text){node.textContent=newText;}
  }

  function updateAllDates(root){
    var context=root||document;
    var selectors=[
      '.jdgm-rev__timestamp',
      '.jdgm-carousel__item__timestamp',
      '.jdgm-carousel-item__timestamp'
    ];
    for(var i=0;i<selectors.length;i++){
      var nodes=context.querySelectorAll(selectors[i]);
      for(var j=0;j<nodes.length;j++){
        formatDateInNode(nodes[j]);
      }
    }
  }

  document.addEventListener('DOMContentLoaded',function(){
    updateAllDates();

    var observer=new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i++){
        var mutation=mutations[i];
        if(mutation.type==='childList'&&mutation.addedNodes.length>0){
          for(var k=0;k<mutation.addedNodes.length;k++){
            var node=mutation.addedNodes[k];

            // Fall 1: Textknoten (wie im Homepage-Carousel)
            if(node.nodeType===3){
              var p=node.parentNode;
              if(p&&p.matches&&p.matches('.jdgm-rev__timestamp, .jdgm-carousel__item__timestamp, .jdgm-carousel-item__timestamp')){
                formatDateInNode(p);
              }
              continue;
            }

            // Fall 2: neue Elemente
            if(!(node instanceof HTMLElement))continue;
            if(node.matches&&node.matches('.jdgm-rev__timestamp, .jdgm-carousel__item__timestamp, .jdgm-carousel-item__timestamp')){
              formatDateInNode(node);
            }
            updateAllDates(node);
          }
        }
      }
    });

    observer.observe(document.body,{childList:true,subtree:true});
  });
})();
// END Judge.me Datum-Format korrigieren

//Sortierfolge von Filter umkehren
(function () {
  // IDs des Modell-Filter-Containers (Desktop + Mobile)
  const MODELL_FILTER_IDS = [
    'Details-filter.p.m.custom.modell_filter-template--26349241499912__product-grid',
    'MobDetails-filter.p.m.custom.modell_filter-template--26349241499912__product-grid'
  ];

  /**
   * Kehrt die Reihenfolge der Filter-Einträge um und weist
   * show-more-item/hidden-Klassen korrekt neu zu.
   */
  function reorderModellFilter(container) {
    if (!container) return;
    const ul = container.querySelector('ul');
    if (!ul) return;

    const lis = Array.from(ul.querySelectorAll(':scope > li'));
    if (lis.length === 0) return;

    // Anzahl der initial sichtbaren Einträge merken
    const visibleCount = lis.filter(
      (li) => !li.classList.contains('show-more-item')
    ).length;

    // Reihenfolge umkehren (neueste zuerst)
    lis.slice().reverse().forEach((li) => ul.appendChild(li));

    // show-more-item / hidden Klassen neu zuweisen
    Array.from(ul.querySelectorAll(':scope > li')).forEach((li, i) => {
      if (i < visibleCount) {
        li.classList.remove('show-more-item', 'hidden');
      } else {
        li.classList.add('show-more-item', 'hidden');
      }
    });
  }

  /**
   * Führt die Umsortierung in einem geparsten HTML-Dokument durch
   * (wird für den Patch des AJAX-Renders verwendet).
   */
  function reorderInDoc(doc) {
    MODELL_FILTER_IDS.forEach((id) => {
      // Punkte und Slashes in der ID escapen für querySelector
      const selector = '#' + id.replace(/\./g, '\\.').replace(/\//g, '\\/');
      const container = doc.querySelector(selector);
      if (container) reorderModellFilter(container);
    });
  }

  // ── 1. Initiale Umsortierung beim Seitenload ─────────────────────────────
  MODELL_FILTER_IDS.forEach((id) => {
    const selector = '#' + id.replace(/\./g, '\\.').replace(/\//g, '\\/');
    const container = document.querySelector(selector);
    if (container) reorderModellFilter(container);
  });

  // ── 2. Patch von FacetFiltersForm.renderFilters (AJAX-Updates) ───────────
  // Shopify ruft diese statische Methode mit dem neuen HTML-String auf,
  // wenn ein Filter aktiviert/deaktiviert wird.
  // Wir ordnen im HTML-String um, BEVOR er in den DOM geschrieben wird
  // → kein Flackern, kein Reset.
  const waitForFacetClass = setInterval(() => {
    const FacetClass = customElements.get('facet-filters-form');
    if (!FacetClass || FacetClass._modellFilterPatched) return;

    clearInterval(waitForFacetClass);

    const _orig = FacetClass.renderFilters;
    FacetClass.renderFilters = function (html, event) {
      if (typeof html === 'string' && html.includes('modell_filter')) {
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          reorderInDoc(doc);
          html = doc.documentElement.outerHTML;
        } catch (e) {
          console.warn('[Modell Filter] Reorder error:', e);
        }
      }
      return _orig.call(this, html, event);
    };

    FacetClass._modellFilterPatched = true;
  }, 100);
})();
//ende sortierfolge umkehren 

// Sticky CTA: Ein-/Ausblenden nach Scroll & Tidio-Widget-Steuerung
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    var stickyCta = document.querySelector('.sticky-cta');
    if (!stickyCta) return;

    var buyButton = document.querySelector('.product-form__buttons, [name="add"]');
    var stickyBtn = stickyCta.querySelector('.sticky-cta__custom-button');
    var mobileBreakpoint = 768;

    function isMobile() {
      return window.innerWidth <= mobileBreakpoint;
    }

    function pulseButton() {
      if (!stickyBtn) return;
      if (stickyCta.classList.contains('sticky-cta--force-hide')) return;

      // Direkt per inline-style setzen — schlägt garantiert jede CSS-Spezifität
      stickyBtn.style.animation = 'none';
      void stickyBtn.offsetWidth; // Reflow erzwingen
      stickyBtn.style.animation = 'stickyPulse 1.2s ease-in-out';

      setTimeout(function () {
        stickyBtn.style.animation = '';
      }, 1300);
    }

    setInterval(pulseButton, 6000);

    function hideTidio() {
      if (window.tidioChatApi) {
        window.tidioChatApi.hide();
      } else {
        document.addEventListener('tidioChat-ready', function () {
          window.tidioChatApi.hide();
        }, { once: true });
      }
    }

    function showTidio() {
      if (window.tidioChatApi) window.tidioChatApi.show();
    }

    function showSticky() {
      var wasHidden = stickyCta.classList.contains('sticky-cta--force-hide');
      stickyCta.classList.remove('sticky-cta--force-hide');
      hideTidio();
      if (wasHidden) {
        setTimeout(pulseButton, 500);
      }
    }

    function hideSticky() {
      stickyCta.classList.add('sticky-cta--force-hide');
      showTidio();
    }

    if (isMobile()) {
      showSticky();
    } else {
      hideSticky();
    }

    function getVisibleViewportTop() {
      var header = document.querySelector('sticky-header');
      if (header) {
        return Math.max(0, header.getBoundingClientRect().bottom);
      }

      var rootStyles = getComputedStyle(document.documentElement);
      var cssHeight = parseFloat(rootStyles.getPropertyValue('--header-height-live'))
        || parseFloat(rootStyles.getPropertyValue('--header-height'));

      return cssHeight || 0;
    }

    function isBuyButtonVisible(element) {
      if (!element) return false;

      var rect = element.getBoundingClientRect();
      var topBound = getVisibleViewportTop();
      var viewportHeight = window.innerHeight;

      return rect.bottom > topBound && rect.top < viewportHeight;
    }

    function updateStickyVisibility(entryOrElement) {
      if (isMobile()) {
        showSticky();
        return;
      }

      // Desktop: Sticky sobald der Warenkorb-Button nicht mehr sichtbar ist
      // (inkl. Verdeckung durch sticky Header oben oder unterhalb des Viewports).
      var isVisible = typeof entryOrElement.isIntersecting === 'boolean'
        ? entryOrElement.isIntersecting
        : isBuyButtonVisible(entryOrElement);

      if (isVisible) {
        hideSticky();
      } else {
        showSticky();
      }
    }

    var buyButtonObserver;

    function setupBuyButtonObserver() {
      if (!buyButton || !('IntersectionObserver' in window)) return;

      if (buyButtonObserver) buyButtonObserver.disconnect();

      var topOffset = getVisibleViewportTop();
      buyButtonObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          updateStickyVisibility(entry);
        });
      }, {
        threshold: [0],
        rootMargin: '-' + topOffset + 'px 0px 0px 0px'
      });

      buyButtonObserver.observe(buyButton);
    }

    if (buyButton && 'IntersectionObserver' in window) {
      setupBuyButtonObserver();

      window.addEventListener('resize', function () {
        setupBuyButtonObserver();
        updateStickyVisibility(buyButton);
      }, { passive: true });

    } else if (buyButton) {
      function onScroll() {
        updateStickyVisibility(buyButton);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

  });
})();
// Ende: Sticky CTA Scroll & Tidio

// Language Banner: liegt in snippets/revendo-lang-banner.liquid, weil er
// synchron vor dem ersten Paint laufen muss (sonst 0.133 CLS).

// Tidio Chat: Deferred Loading nach erster Nutzerinteraktion
// ─────────────────────────────────────────────────────────────────────────────
// Tidio wird NICHT mehr über den Shopify App Embed Block geladen (dort deaktiv-
// iert), sondern erst nachdem der Nutzer das erste Mal mit der Seite interagiert
// (Tippen, Scrollen, Mausbewegung, Klick). Das entlastet den Main Thread beim
// initialen Seitenaufruf und verbessert den INP-Wert (Interaction to Next Paint).
//
// Die bestehenden Funktionen hideTidio() / showTidio() im Sticky-CTA-Block funk-
// tionieren weiterhin korrekt: hideTidio() lauscht bereits auf das Event
// 'tidioChat-ready' und versteckt das Widget, sobald es geladen wurde.
//
// Fallback: Nach 5 Sekunden wird Tidio auch ohne Interaktion geladen, damit das
// Chat-Widget für passive Besucher (die nur lesen) trotzdem verfügbar ist.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  var loaded = false;

  function loadTidio() {
    if (loaded) return;
    loaded = true;
    var s = document.createElement('script');
    s.src = '//code.tidio.co/ss0oytboqjhrxto9upb8btz8eqg1kn0k.js';
    s.async = true;
    document.body.appendChild(s);
  }

  ['touchstart', 'mousemove', 'scroll', 'click'].forEach(function (evt) {
    window.addEventListener(evt, loadTidio, { once: true, passive: true });
  });

  setTimeout(loadTidio, 5000);
})();
// Ende: Tidio Deferred Loading

// Klaviyo Onsite: Deferred Loading nach erster Nutzerinteraktion
// ─────────────────────────────────────────────────────────────────────────────
// Klaviyo wird NICHT mehr über den Shopify App Embed Block geladen (dort deakti-
// viert), sondern nach der ersten Interaktion. Das Onsite-Bundle zieht rund 40
// weitere Chunks nach und war damit der grösste Einzelposten der ~513 Requests
// auf der Startseite.
//
// Der Fallback ist mit 3s kürzer als bei Tidio: Klaviyo transportiert Tracking
// (u. a. "Viewed Product" für Browse-Abandonment-Flows), Tidio nur ein Chat-
// Widget. Besucher, die vor Ablauf der 3s ohne jede Interaktion abspringen,
// werden onsite nicht mehr erfasst — Bestell- und Checkout-Events laufen davon
// unabhängig über Klaviyos eigenes Web-Pixel (Server + Web) weiter.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  var COMPANY_ID = 'VDxmP7';
  var loaded = false;

  function loadKlaviyo() {
    if (loaded) return;
    loaded = true;

    // Schützt vor Doppelladung, falls das App Embed im Theme-Editor wieder
    // aktiviert wird — dann bringt Shopify klaviyo.js bereits selbst mit.
    if (document.querySelector('script[src*="klaviyo.com/onsite/js"]')) return;

    var s = document.createElement('script');
    s.src = 'https://static.klaviyo.com/onsite/js/' + COMPANY_ID + '/klaviyo.js?company_id=' + COMPANY_ID;
    s.async = true;

    s.onload = function () {
      var payload = window.revendoKlaviyoIdentify;
      if (payload && window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(payload);
      }
    };

    document.head.appendChild(s);
  }

  ['touchstart', 'mousemove', 'scroll', 'click', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, loadKlaviyo, { once: true, passive: true });
  });

  setTimeout(loadKlaviyo, 3000);
})();
// Ende: Klaviyo Deferred Loading

// Revendo: Variant picker — in-place sync (no DOM swap flicker on mobile)
(function () {
  function escapeSelector(value) {
    if (typeof CSS !== 'undefined' && CSS.escape) return CSS.escape(String(value));
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function syncInnerIfChanged(oldEl, newEl) {
    if (oldEl && newEl && oldEl.innerHTML !== newEl.innerHTML) {
      oldEl.innerHTML = newEl.innerHTML;
    }
  }

  function syncVariantSelectsInPlace(oldRoot, newRoot) {
    if (!oldRoot || !newRoot) return false;

    // Dropdown-Picker: NiceSelect rendert eine eigene UI, die sich nicht
    // in-place aktualisieren lässt — auf den Original-Swap zurückfallen.
    if (oldRoot.querySelector('select[name^="options"]')) return false;

    var oldFieldsets = oldRoot.querySelectorAll('fieldset');
    var newFieldsets = newRoot.querySelectorAll('fieldset');
    if (oldFieldsets.length !== newFieldsets.length) return false;

    var newVariantData = newRoot.querySelector('[data-selected-variant]');
    var oldVariantData = oldRoot.querySelector('[data-selected-variant]');
    if (newVariantData && oldVariantData) {
      oldVariantData.textContent = newVariantData.textContent;
    }

    var newRadios = newRoot.querySelectorAll('input[type="radio"][data-option-value-id]');
    for (var i = 0; i < newRadios.length; i++) {
      var newInput = newRadios[i];
      var optionValueId = newInput.dataset.optionValueId;
      var oldInput = oldRoot.querySelector(
        'input[type="radio"][data-option-value-id="' + optionValueId + '"]'
      );
      if (!oldInput) return false;

      oldInput.checked = newInput.checked;
      oldInput.disabled = newInput.disabled;
      oldInput.classList.toggle('disabled', newInput.classList.contains('disabled'));

      if (newInput.dataset.customQuickInfo) {
        oldInput.dataset.customQuickInfo = newInput.dataset.customQuickInfo;
      } else {
        delete oldInput.dataset.customQuickInfo;
      }

      // Sprungziel fuer den Wechsel auf verfuegbare Kombination haengt von
      // der aktuellen Selektion ab und muss bei jedem Sync mitkommen, sonst
      // springen Folgeklicks mit veralteten Zielen oder gar nicht.
      if (newInput.dataset.revendoJumpName) {
        oldInput.dataset.revendoJumpName = newInput.dataset.revendoJumpName;
        oldInput.dataset.revendoJumpValue = newInput.dataset.revendoJumpValue;
      } else {
        delete oldInput.dataset.revendoJumpName;
        delete oldInput.dataset.revendoJumpValue;
      }

      var newLabel = newRoot.querySelector('label[for="' + escapeSelector(newInput.id) + '"]');
      var oldLabel = oldRoot.querySelector('label[for="' + escapeSelector(oldInput.id) + '"]');
      if (newLabel && oldLabel) syncInnerIfChanged(oldLabel, newLabel);
    }

    for (var f = 0; f < newFieldsets.length; f++) {
      var newFs = newFieldsets[f];
      var oldFs = oldFieldsets[f];

      syncInnerIfChanged(
        oldFs.querySelector('.poc-quick-info-display[data-poc-option]'),
        newFs.querySelector('.poc-quick-info-display[data-poc-option]')
      );

      var newSel = newFs.querySelector('[data-selected-value]');
      var oldSel = oldFs.querySelector('[data-selected-value]');
      syncInnerIfChanged(oldSel, newSel);
    }

    return true;
  }

  function patchProductInfoVariantSync() {
    var ProductInfo = customElements.get('product-info');
    if (!ProductInfo || ProductInfo.prototype._revendoVariantSyncPatched) return;
    ProductInfo.prototype._revendoVariantSyncPatched = true;

    var originalUpdate = ProductInfo.prototype.updateOptionValues;
    ProductInfo.prototype.updateOptionValues = function (html) {
      var newVariantSelects = html.querySelector('variant-selects');
      var oldVariantSelects = this.variantSelectors;
      if (newVariantSelects && oldVariantSelects && syncVariantSelectsInPlace(oldVariantSelects, newVariantSelects)) {
        return;
      }
      return originalUpdate.call(this, html);
    };
  }

  if (customElements.get('product-info')) {
    patchProductInfoVariantSync();
  } else {
    customElements.whenDefined('product-info').then(patchProductInfoVariantSync);
  }
  document.addEventListener('product-info:loaded', patchProductInfoVariantSync);

  function updateQuickInfoDisplay(display) {
    if (!display) return;
    var optionKey = display.dataset.pocOption;
    if (!optionKey) return;
    var fieldset = display.closest('fieldset');
    var root = fieldset || display.closest('variant-selects') || document;
    var checked = root.querySelector('input[data-poc-option="' + optionKey + '"]:checked');
    var next = checked && checked.dataset.customQuickInfo ? checked.dataset.customQuickInfo : '';
    if (display.innerHTML !== next) display.innerHTML = next;
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[type="radio"][data-poc-option]')) return;
    var fieldset = input.closest('fieldset');
    if (!fieldset) return;
    var display = fieldset.querySelector(
      '.poc-quick-info-display[data-poc-option="' + input.dataset.pocOption + '"]'
    );
    updateQuickInfoDisplay(display);
  });
})();
// END Revendo: Variant picker sync

// Revendo: Breezy Jobs – Multicolumn Theme-Klassen auf Embed-Markup anwenden
(function () {
  var CARD_LINK_CLASSES = [
    'multicolumn-card',
    'responsive-card-padding',
    'overflow-hidden',
    'flex',
    'flex-col',
    'content-container',
    'gradient',
    'full-unstyled-link--foreground',
    'focus-this-inner-inset'
  ];

  function ensureClasses(el, classes) {
    classes.forEach(function (cls) {
      el.classList.add(cls);
    });
  }

  function extractJobParts(link) {
    var info = link.querySelector('.multicolumn-card__info');
    var heading = link.querySelector('h2');
    var meta = link.querySelector('ul.bzMeta');
    var applyButton = link.querySelector('.bzButtonApply');

    if (info) {
      if (!heading) heading = info.querySelector('h2');
      if (!meta) meta = info.querySelector('ul.bzMeta');
      if (!applyButton) applyButton = info.querySelector('.bzButtonApply');
      info.remove();
    }

    link.querySelectorAll('.banner__buttons').forEach(function (wrap) {
      wrap.remove();
    });

    return { heading: heading, meta: meta, applyButton: applyButton };
  }

  function styleJobItem(item, sectionScheme, cardScheme, showShadow, applyLabel) {
    item.classList.add('multicolumn-list__item', 'grid__item');
    item.classList.add(
      sectionScheme !== cardScheme ? 'color-schemes--different' : 'color-schemes--matching'
    );

    var link = item.querySelector(':scope > a');
    if (!link) return;

    var parts = extractJobParts(link);
    ensureClasses(link, CARD_LINK_CLASSES);
    link.classList.add('color-' + cardScheme);
    if (showShadow) {
      link.classList.add('card--shadow');
    } else {
      link.classList.remove('card--shadow');
    }
    link.style.setProperty('--responsive-card-padding', '3rem');

    var info = document.createElement('div');
    info.className =
      'multicolumn-card__info card-padding flex flex-col md:flex-row md:items-center md:justify-between gap-1 w-full';

    var body = document.createElement('div');
    body.className = 'flex flex-col gap-05 min-w-0 grow';

    if (parts.heading) {
      parts.heading.className =
        'multicolumn-card__heading lh-13 mt-0 mb-0 inline-richtext h5';
      body.appendChild(parts.heading);
    }

    if (parts.meta) {
      parts.meta.className =
        'list-unstyled bmrk-tags bmrk-tags--phat flex flex-wrap gap-05 t7 mb-0';
      body.appendChild(parts.meta);
    }

    if (body.childElementCount) {
      info.appendChild(body);
    }

    if (parts.applyButton) {
      parts.applyButton.className = 'bzButtonApply button button--primary';
      if (applyLabel) {
        parts.applyButton.textContent = applyLabel;
      }
      var btnWrap = document.createElement('div');
      btnWrap.className =
        'banner__buttons banner__buttons--multiple shrink-0 mt-1 md:mt-0 md:ml-2';
      btnWrap.appendChild(parts.applyButton);
      info.appendChild(btnWrap);
    }

    link.appendChild(info);
  }

  function styleBreezyJobs(container, observer) {
    if (!container) return;

    var list = container.querySelector('ul.bzOpeningsList');
    if (!list) return;

    var section = container.closest('.revendo-jobs');
    var sectionScheme = (section && section.dataset.revendoSectionColor) || 'scheme-1';
    var cardScheme = (section && section.dataset.revendoCardColor) || 'scheme-1';
    var showShadow = section && section.dataset.revendoCardShadow === 'true';
    var applyLabel = section && section.dataset.applyLabel;

    container.__revendoJobsStyling = true;
    if (observer) observer.disconnect();

    ensureClasses(list, [
      'multicolumn-list',
      'contains-content-container',
      'section-grid',
      'grid',
      'mb-0',
      'grid--1-col',
      'grid--1-col-desktop',
      'grid--1-col-tablet-down'
    ]);

    container.querySelectorAll('li.bzOpening').forEach(function (item) {
      styleJobItem(item, sectionScheme, cardScheme, showShadow, applyLabel);
    });

    if (observer) observer.observe(container, { childList: true, subtree: true });
    container.__revendoJobsStyling = false;
  }

  function initBreezyJobs() {
    var container = document.getElementById('bzOpeningsContainer');
    if (!container) return;

    if (container.__revendoJobsObserver) {
      styleBreezyJobs(container, container.__revendoJobsObserver);
      return;
    }

    var observer = new MutationObserver(function () {
      if (container.__revendoJobsStyling) return;
      styleBreezyJobs(container, observer);
    });

    observer.observe(container, { childList: true, subtree: true });
    container.__revendoJobsObserver = observer;
    styleBreezyJobs(container, observer);
  }

  document.addEventListener('DOMContentLoaded', initBreezyJobs);
  document.addEventListener('shopify:section:load', initBreezyJobs);
})();
// END Revendo: Breezy Jobs
// Revendo: Sidecart Wunschliste (eigene Wishlist-Rocket-App, App-Proxy /apps/wishlist)
// Konventionen identisch zur App: Gast-Wishlist unter localStorage
// "revendoWishlistGuest" ({productId, productHandle}), damit der Server-Merge
// nach dem Login greift. 401 vom Proxy = Gast; ob Gaeste erlaubt sind,
// entscheidet das App-Setting requireLogin (per GET erfragt, einmal gecacht).
(function () {
  'use strict';

  var API = '/apps/wishlist';
  var GUEST_KEY = 'revendoWishlistGuest';
  var requireLogin = null; // null = noch unbekannt

  function guestItems() {
    try { return JSON.parse(localStorage.getItem(GUEST_KEY)) || []; } catch (e) { return []; }
  }
  function setGuestItems(items) {
    try { localStorage.setItem(GUEST_KEY, JSON.stringify(items)); } catch (e) {}
  }
  function hasGuestItem(productId) {
    return guestItems().some(function (i) { return String(i.productId) === String(productId); });
  }
  function loginRedirect() {
    var target = window.location.pathname + window.location.search;
    window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(target);
  }
  function markAdded(btn) {
    btn.setAttribute('aria-pressed', 'true');
    if (btn.dataset.addedLabel) btn.textContent = btn.dataset.addedLabel;
  }
  // Verschieben statt nur merken (Verhalten wie produktiv): nach dem
  // Wunschlisten-Eintrag die Zeile ueber den Theme-eigenen Entfernen-Button
  // aus dem Warenkorb nehmen – cart.js uebernimmt Request und Re-Render.
  function removeLine(btn) {
    var row = btn.closest('.cart-item');
    var remove = row && row.querySelector('cart-remove-button:not(.hidden) button');
    if (remove) remove.click();
  }
  function moveToWishlist(btn) {
    markAdded(btn);
    removeLine(btn);
  }
  function fetchRequireLogin() {
    if (requireLogin !== null) return Promise.resolve(requireLogin);
    return fetch(API, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        requireLogin = Boolean(data.requireLogin);
        return requireLogin;
      })
      .catch(function () { requireLogin = false; return requireLogin; });
  }
  function addGuest(btn) {
    if (!hasGuestItem(btn.dataset.productId)) {
      setGuestItems(guestItems().concat([{
        productId: btn.dataset.productId,
        productHandle: btn.dataset.productHandle
      }]));
    }
    moveToWishlist(btn);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rv-wishlist-add]');
    if (!btn || btn.getAttribute('aria-pressed') === 'true') return;
    // Production: Swish/Wishlist-King injiziert pro Position einen eigenen
    // (per CSS versteckten) Save-for-later-Button. Wenn er da ist, delegieren
    // wir den Klick – Swish uebernimmt Wunschliste, Login-Gate und das
    // Entfernen der Zeile. Ohne Swish (Staging / nach der Migration auf
    // Wishlist Rocket) laeuft der eigene Flow unten.
    var row = btn.closest('.cart-item');
    var swish = row && row.querySelector('save-for-later button');
    if (swish) { swish.click(); return; }
    // Erst als eingeloggter Kunde versuchen; 401 heisst Gast.
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ intent: 'add', productId: btn.dataset.productId })
    }).then(function (res) {
      if (res.ok) { moveToWishlist(btn); return; }
      if (res.status === 401) {
        return fetchRequireLogin().then(function (req) {
          if (req) { loginRedirect(); } else { addGuest(btn); }
        });
      }
      // ponytail: Proxy nicht erreichbar -> Gast-Speicher als Fallback,
      // der Merge nach Login raeumt das spaeter auf.
      addGuest(btn);
    }).catch(function () { addGuest(btn); });
  });

  // Keine Vormarkierung aus dem Gast-Speicher: der Link VERSCHIEBT die Zeile
  // (sie verschwindet beim Klick), ein vormarkierter Button wuerde das nur
  // blockieren. Doppelte Wunschlisten-Eintraege verhindert addGuest bzw.
  // der Server selbst.
})();
// END Revendo: Sidecart Wunschliste

// Revendo: Sidecart-Preisformat – Tausender mit Apostroph (de-CH)
// Das Store-money_format trennt Tausender mit Leerzeichen ("1 788 CHF"),
// der Entwurf und money_with_currency (Footer-Total) mit Apostroph.
// Statt Liquid-Postprocessing an jeder Preis-Ausgabe (5 Call-Sites im
// Vendor-File): ein Text-Reformat nach dem Muster der Judge.me-Datums-
// formatierung oben. Funktioniert format-unabhaengig (Prefix "CHF 1 234.00"
// wie Suffix "1 234 CHF"), weil nur Ziffergruppen umgruppiert werden.
// ponytail: sauberer waere ein konsistentes money_format im Shopify-Admin,
// dann kann dieses Modul ersatzlos weg.
(function () {
  'use strict';

  // "1 788" / "CHF 3,022.00" -> "1'788" / "CHF 3'022.00" (auch NBSP-Varianten).
  // Komma zaehlt nur mit exakt 3 Folgeziffern als Tausendertrenner – ein
  // Dezimalkomma ("3.022,00") hat 2 und bleibt unangetastet.
  var GROUP = /(\d)[ \u00A0\u202F,](\d{3})(?!\d)/g;

  function formatNode(node) {
    var text = node.textContent;
    if (!GROUP.test(text)) return;
    GROUP.lastIndex = 0;
    var next = text;
    var prev;
    do { prev = next; next = prev.replace(GROUP, "$1'$2"); } while (next !== prev);
    if (next !== text) node.textContent = next;
  }

  function formatPrices(root) {
    (root || document)
      .querySelectorAll('#CartDrawer .cart-item__price-wrapper, #CartDrawer .totals')
      .forEach(function (el) {
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        var n;
        while ((n = walker.nextNode())) formatNode(n);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    formatPrices();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // cart.js rendert den Drawer bei jeder Aenderung neu. formatNode schreibt
    // nur bei tatsaechlicher Aenderung -> keine Endlosschleife mit dem Observer.
    new MutationObserver(function () { formatPrices(drawer); })
      .observe(drawer, { childList: true, subtree: true, characterData: true });
  });
})();
// END Revendo: Sidecart-Preisformat

// Revendo: PDP — Klick auf eine Zustand-Pill, deren Kombination mit
// der anderen Zustand-Option ausverkauft ist, springt auf die lagerstaerkste
// verfuegbare Kombination. Das Sprungziel steht serverseitig berechnet als
// data-revendo-jump-name/-value am Radio (revendo-variant-option-attrs.liquid).
// Capture-Listener: laeuft VOR dem change-Handler von <variant-selects>,
// dadurch liest das Theme direkt den korrigierten Zustand und rendert genau
// einmal — kein zweiter Fetch, kein Flackern.
(function () {
  // Merkt sich, ob der letzte Wechsel ein bewusster Klick auf eine als
  // ausverkauft markierte Pill war — dann zeigt Teil 2 die Sold-out-Ansicht
  // statt wegzuspringen (Benachrichtigung, bewusste Auswahl).
  var deliberateSoldOutClick = false;
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio' || !input.closest || !input.closest('variant-selects')) return;
    deliberateSoldOutClick = input.classList.contains('disabled');
    if (!input.dataset || !input.dataset.revendoJumpName || !input.checked) return;
    var root = input.closest('variant-selects');
    var radios = root.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      if (
        radio.name.trim() === input.dataset.revendoJumpName &&
        radio.value === input.dataset.revendoJumpValue &&
        !radio.disabled
      ) {
        radio.checked = true;
        break;
      }
    }
  }, true);

  // Teil 2: Steht die Selektion auf einer ausverkauften Kombination, obwohl
  // die gewaehlte Pill selbst verfuegbar waere, traegt die angehakte Pill das
  // serverseitig berechnete Sprungziel - einmal "change" ausloesen, danach
  // laeuft alles wie bei einem echten Klick. Faelle: Sold-out-Landing per
  // ?variant=-Link, Geschwister-Wechsel auf Combined-Listing-Seiten, und
  // schnelle Folgeklicks, deren Pill noch veraltete Sprungziele aus dem
  // vorherigen Rendering trug. Terminiert immer: das Sprungziel ist
  // verfuegbar, dessen Rendering traegt auf der angehakten Pill keine
  // Sprung-Attribute mehr, und ohne existierendes, noch nicht angehaktes
  // Sprungziel wird gar nicht erst ausgeloest.
  function jumpToAvailableCombination() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (deliberateSoldOutClick) return;
    var checked = document.querySelector(
      'variant-selects input[type="radio"]:checked[data-revendo-jump-name]'
    );
    if (!checked) return;
    var root = checked.closest('variant-selects');
    if (!root) return;
    var radios = root.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (
        radios[i].name.trim() === checked.dataset.revendoJumpName &&
        radios[i].value === checked.dataset.revendoJumpValue &&
        !radios[i].checked &&
        !radios[i].disabled
      ) {
        checked.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }
  function armJump() {
    setTimeout(jumpToAvailableCombination, 0);
  }
  // Wartet auf product-info UND product-form (beide lazy geladen): ohne
  // product-info verpufft der Wechsel, ohne product-form fehlt danach der
  // Warenkorb-Button-Toggle.
  if (window.customElements && customElements.whenDefined) {
    Promise.all([
      customElements.whenDefined('product-info'),
      customElements.whenDefined('product-form'),
    ]).then(function () {
      armJump();
      document.addEventListener('product-info:loaded', armJump);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, armJump);
      }
    });
  }
})();
// END Revendo: PDP Sprung auf verfuegbare Kombination
